import { Badge } from "@/components/ui/badge"

import { BaseUserPublic } from "@/types/users"
import SocialLinks from "./SocialLinks"
import ClickableHoverCard from "../ClickableHoverCard"
import { AuthorAvatar } from "@/app/components/Avatar"
import TruncatedText from "@/app/components/TruncatedText"

export default function AuthorHoverCard({
  author,
}: {
  author: BaseUserPublic
}) {
  return (
    <ClickableHoverCard
      trigger={
        <Badge variant="tag" className="flex gap-1 items-center">
          <AuthorAvatar
            user={author}
            size={16}
            className="w-4 h-4 "
            noFallback
          />
          <span className="text-muted-foreground font-normal text-sm">
            {author.displayName.name}
          </span>
        </Badge>
      }
    >
      <div>
        <p className="text-sm font-semibold mb-2 text-foreground">
          {author.displayName.name}
        </p>
        {author.authorBio && (
          <TruncatedText
            maxLength={120}
            text={author.authorBio}
            className="text-sm font-normal text-muted-foreground"
          />
        )}
      </div>
      <SocialLinks
        className="text-muted-foreground mt-4"
        socials={author.social}
        walletAddress={author.lowercase_wallet_address}
      />
    </ClickableHoverCard>
  )
}
